import store from '../../../core/store';

export const setAttachmentParams = (params) => {
  store.dispatch({
    type: 'general.attachments/SET_PARAMS',
    params,
  });
};
